// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/fonts/iconfont.css
// module id = 21
// module chunks = 0